import { Pie } from "@ant-design/charts";
import type { CardProps } from "antd";
import i18n from "i18next";
import type { FC } from "react";

import { DashboardCardContainer } from "src/app/features/Dashboard/utils/dashboardStyles";
import { Palette } from "../../../../core/styles/palette";
import type { AcceptedCardTypeDto } from "../types/Dashboard";

interface AcceptedCardTypesCardProps extends CardProps {
    data: AcceptedCardTypeDto[];
}

/**
 * AcceptedCardTypesCard - Pie chart showing accepted card types distribution
 */
export const AcceptedCardTypesCard: FC<AcceptedCardTypesCardProps> = ({ data, ...cardProps }) => {
    // Sort data by value descending for better visualization
    const sortedData = [...data].sort((a, b) => b.value - a.value);
    const total = sortedData.reduce((sum, d) => sum + d.value, 0);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const config: any = {
        appendPadding: 10,
        data: sortedData,
        angleField: "value",
        colorField: "type",
        radius: 0.9,
        innerRadius: 0,
        style: {
            stroke: Palette.White,
            lineWidth: 3,
        },
        label: {
            text: (item: AcceptedCardTypeDto) => {
                const percent = ((item.value / total) * 100).toFixed(0);
                return `${percent}%`;
            },
            style: {
                fontSize: 14,
                fill: Palette.White,
                textAlign: "center",
                fontWeight: "bold",
            },
        },
        legend: {
            color: {
                title: false,
                position: "bottom",
                layout: {
                    justifyContent: "center",
                },
            },
        },
        interactions: [
            {
                type: "element-active",
            },
        ],
        tooltip: {
            title: (datum: AcceptedCardTypeDto) => datum.type,
            items: [
                (datum: AcceptedCardTypeDto) => {
                    const percent = ((datum.value / total) * 100).toFixed(1);
                    return {
                        name: "Count",
                        value: `${datum.value} (${percent}%)`,
                    };
                },
            ],
        },
    };

    return (
        <DashboardCardContainer title={i18n.t("dashboard.acceptedCardTypes")} {...cardProps}>
            <div style={{ maxWidth: 520, height: 420, margin: "0 auto" }}>
                <Pie {...config} />
            </div>
        </DashboardCardContainer>
    );
};
